import { v4 as uuid } from 'uuid';
import { md5 } from 'js-md5';
export class CartItem {
    id;
    productId = null;
    quantity = null;
    note = null;
    courseId = null;
    options = {};
    chosen = {};
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
    static generateId(productId) {
        return `${productId}-||-${uuid()}`;
    }
    static getOptionValueIds(rawValue) {
        if (!rawValue) {
            return [];
        }
        if (Array.isArray(rawValue)) {
            return rawValue.filter((v) => Boolean(v));
        }
        return [rawValue];
    }
    getOptionValueIds(optionId) {
        if (!this.options) {
            return [];
        }
        return CartItem.getOptionValueIds(this.options[optionId]);
    }
    getRelevantInfoHash() {
        let info = {
            productId: this.productId,
            note: this.note,
            courseId: this.courseId,
            chosen: this.chosen,
            options: this.options
        };
        return md5(JSON.stringify(info));
    }
    static accumulateByRelevantInfo(items) {
        let itemsByHash = {};
        if (items) {
            for (let item of items) {
                item = new CartItem(item.id, item);
                let hash = item.getRelevantInfoHash();
                if (!itemsByHash[hash]) {
                    itemsByHash[hash] = item;
                    item.quantity = 0;
                }
                itemsByHash[hash].quantity = itemsByHash[hash].quantity ? itemsByHash[hash].quantity + 1 : 1;
            }
        }
        return Object.values(itemsByHash);
    }
}
